import TextField from "./TextField";
import TextAreaField from "./TextAreaField";
import NumberField from "./NumberField";
import SelectField from "./SelectField";
import MediaFileField from "./MediaFileField";

const InputField = ({
  name,
  param,
  value,
  media = [],
  onChange = () => {},
}) => {
  const formatName = (name) => {
    return name.replace(/_/g, " ").replace(/(?: |\b)(\w)/g, function (key) {
      return key.toUpperCase();
    });
  };

  const handleChange = (e) => {
    if (e.value) {
      onChange(name, e.value);
    } else if (e.target) {
      onChange(name, e.target.value);
    }
  };

  const formattedName = formatName(name);
  let label = <label>{formattedName}</label>;
  let input = <></>;
  switch (param.type) {
    case "text":
    case "string":
      input = (
        <TextField
          name={name}
          value={value}
          param={param}
          onChange={handleChange}
        />
      );
      break;
    case "textarea":
      input = (
        <TextAreaField
          name={name}
          value={value}
          param={param}
          onChange={handleChange}
        />
      );
      break;
    case "number":
      input = (
        <NumberField
          name={name}
          value={value}
          param={param}
          onChange={handleChange}
        />
      );
      break;
    case "select":
      input = (
        <SelectField
          name={name}
          value={value}
          param={param}
          onChange={handleChange}
        />
      );
      break;
    case "media_file":
      input = (
        <MediaFileField
          name={name}
          value={value}
          param={param}
          media={media}
          onChange={handleChange}
        />
      );
      break;
    default:
  }

  return (
    <>
      {label}
      {input}
    </>
  );
};

export default InputField;
